export function dispatchEvent(eventId: string, value?: unknown): void {
    // disable dispatch events, because we use server side rendering
    if (typeof document === 'undefined') {
        return;
    }

    const customEvent = new CustomEvent(eventId, { detail: value });

    document.dispatchEvent(customEvent);
}
